import React, { Component, Fragment } from "react";
import { StepDiv } from "./../../StyledComponents";
import ButtonStep from "./../../ButtonStep";
import ConfirmButton from "./../../../buttons/ConfirmButton";
import _ from "lodash";

import { Tabs, Row, Col } from "antd";
import SurveyStepActionsKpiTab from "./SurveyStepActionsKpiTab";
import Summary from "./../Summary";
import ComVisit from "./ComVisit";

class SurveyStepActionsKpi extends Component {
  sucess = () => {
    if (this.state.ActiveKey <= this.state.lenghtTabAction) {
      this.setState({ ActiveKey: this.state.ActiveKey + 1 });
    }
    if (this.state.ActiveKey === this.state.lenghtTabAction) {
      this.props.next();
    }
    if (this.state.ActiveKey === -1) {
      this.props.prev();
    }
  };
  state = {
    listTabsSelect: [],
    ActiveKey: 0,
    lenghtTabAction: null,
    simulationDisplayed: null
  };

  componentDidMount() {
    //init locations
    //let locations = this.props.surveyProgressModel.locationsStructure || [];
    let locations = this.props.locations || [];
    for (let i = 0; i < locations.length; i++) {
      const location = locations[i];
      //this.props.surveyUpdateLocationTypes(location);
    }
  }

  /**
   * Move simulation to the next locationType
   * @param tabIndex
   */
  updateSimulation(tabIndex = 0) {
    //this.props.gotoLocationType(tabIndex);
  }

  renderTabs() {
    //let locations = this.props.surveyProgressModel.locationsStructure || [];
    let locations = this.props.locations || [];
    const tabs = [];
    _.forEach(locations, (location, index) => {
      tabs.push(
        <Tabs.TabPane tab={location.label} key={index}>
          <SurveyStepActionsKpiTab locationType={location} />
        </Tabs.TabPane>
      );
    });

    return (
      <Tabs
        onTabClick={tabIndex => {
          this.updateSimulation(tabIndex);
        }}
      >
        {tabs}
      </Tabs>
    );
  }

  render() {
    const { current, steps, prev, next, sucess, disabled, handleDisabled, nextDisabled } = this.props;

    handleDisabled(nextDisabled);
    return (
      <Fragment>
        <ButtonStep
          current={current}
          steps={steps}
          prev={() => prev(current)}
          next={() => next(current)}
          sucess={() => sucess(current)}
          disabled={disabled}
        />
        <div className="p-survey-setsimulation" />
        <div className="p-content-item">
          <div className="p-al-full">
            <div className="p-survey-4">{this.renderTabs()}</div>
            <Fragment>
              <Summary />
            </Fragment>
          </div>
          <div className="p-al-right p-mrg-top p-mrg-bot-l">
            <ComVisit />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SurveyStepActionsKpi;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpi.js